import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import "../index.css"

import googleChatIcon from "../../../../images/google_chat_icon.png"

import { TextInputField, Button, DropDownField, InputSwitchField, AutoCompleteField, MultiSelectField } from "../../../../helpers";
import Table from "../../../../helpers/Table"
import { RadioButton } from "primereact/radiobutton";
import { Dialog } from "primereact/dialog"
import { Tooltip } from "primereact/tooltip";
import { OverlayPanel } from 'primereact/overlaypanel';

import { 
    checkPermissions,
    getApproverDetails,
    sortArrayOfObjectsInAscendingDateOrder,
    getFullName
} from '../../../../utils';

import AddShippingAddress from '../../../../common/AddShippingAddress';

import { raiseToast } from '../../../../services/redux/reducers/toast/toast';
import { getPMCompanyConfig } from '../../../../setup/pmCompanyConfig';

import { getGoogleUserChatUri } from '../../../../services/api/googleChat';

const options = ['Yes', 'No'];
const branchTypeOptions = ['HO', 'Plant', 'Admin/ HR', 'Others']

let newPMBranch = {
    branchId: 0,
    branchName: "All",
    statusId: 1
}

const AddBranch = (props) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const moveShipAddrRef = useRef(null)

    const { companyData, formErrors, validationBranchId, companyTypes, previousBranch, companyLevelUsers, relevantKams } = props

    const [branch, setBranch] = useState({})
    const [companyUsersSuggestions, setCompanyUsersSuggestions] = useState([])
    const [paymentTermsApprovalInstanceData, setPaymentTermsApprovalInstanceData] = useState({})
    const [searchedClientSuccessManagers, setSearchedClientSuccessManagers] = useState([])
    const [viewCompanyLevelUsers, setViewCompanyLevelUsers] = useState(false)
    const [viewRelevantKams, setViewRelevantKams] = useState(false)
    const [selectedBranchToMoveShipAddr, setSelectedBranchToMoveShipAddr] = useState(null)
    const [selectedShipAddrId, setSelectedShipAddrId] = useState(null)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    const statusList = useSelector((state) => state.common.status)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)
    const clientSuccessManagers = useSelector(state => state.common.clientSuccessManagers)
    const companyRoleHierarchy = useSelector(state => state.common.companyRoleHierarchy)
    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)

    newPMBranch.companyId = pmCompanyDetails.companyId

    let prefPMBranchPermissionDetails = checkPermissions({ ...userDetails, permissions: [213] })
    const prefPMBranches = [{ ...newPMBranch, optionDisabled: !prefPMBranchPermissionDetails.isPermitted }, ...pmCompanyDetails.companyBranches]

    const filteredBranchForShipAddrMove = companyData.companyBranches.filter(eachBranch => eachBranch.branchId !== branch.branchId)

    useEffect(() => {
        if (props.branch) {
            setBranch({...JSON.parse(JSON.stringify(props.branch)), moveShipAddrsList: []})
        }
    }, [props.branch])

    useEffect(() => {
        if (props.approvalInstancesData) {
            let relatedBranchApprovalInstances = props.approvalInstancesData.filter(eachInstance => eachInstance.companyBranchId === props.branch.branchId)
            let sortedPaymentTermsApprovalInstancesByDate =  sortArrayOfObjectsInAscendingDateOrder(relatedBranchApprovalInstances, "createdAt", "DESC")
            setPaymentTermsApprovalInstanceData(sortedPaymentTermsApprovalInstancesByDate[0])
        }
    }, [props.branch, props.approvalInstancesData])

    const handlePaymentTermsChange = (event, branch_id) => {
        if (branch.paymentTerms) {
            branch.paymentTerms[event.target.name] = event.target.value
        } else {
            branch.paymentTerms = {}
            branch.paymentTerms[event.target.name] = event.target.value
        }

        setBranch({ ...branch })
    }

    const handleToggleSwitchButtonChange = (event) => {
        let updatedBranch = {...branch, exemptedSEZ: event.value}
        updatedBranch.branchGSTINs = updatedBranch.exemptedSEZ ? [] : previousBranch.branchGSTINs
        setBranch({ ...updatedBranch })
    }

    const addCompanyBranchShippingAddr = async (shippingAddrObj) => {

        if (!branch.shipAddrArr || branch?.shipAddrArr.length === 0) {
            branch.shipAddrArr = []
        }

        let shipping_addr_obj = {
            shipAddrId: uuidv4(),
            companyId: props.companyId,
            branchId: props.selectedBranchId,
            shipAddr: shippingAddrObj.address,
            statusId: 1,
            pinCode: shippingAddrObj.pinCode,
            city: shippingAddrObj.city,
            stateId: shippingAddrObj.stateId,
            countryId: shippingAddrObj.countryId,
            isNew: true
        }


        if (window.confirm("Do you want to save the shipping address..?")) {
            branch.shipAddrArr.push(shipping_addr_obj)
            setBranch({ ...branch })
            props.setVisibleShippingAddress(false)
            props.setSelectedBranchId(null)
        }
    }

    const searchClientSuccessManagers = (event) => {
        const relatedClientSuccessManagers = clientSuccessManagers.filter(eachUser => eachUser.fullName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedClientSuccessManagers([...relatedClientSuccessManagers])
    }

    const handleInputChange = (event, branch_id) => {
        if (event.target.name === "prefPMBranchId" && event.target.value === 0 && !prefPMBranchPermissionDetails.isPermitted) {
            return
        }
        branch[event.target.name] = event.target.value
        if (event.target.name === "companyPaymentTerms") {
            if (event.target.value) {
                if (typeof companyData.paymentTerms === 'string') {
                    branch["paymentTerms"] = JSON.parse(companyData.paymentTerms)
                } else {
                    branch["paymentTerms"] = companyData.paymentTerms
                }
            }
            else {
                branch["paymentTerms"] = {
                    payAdvPO: 0,
                    payAdvDelivery: 0,
                    payPDCDelivery: 0,
                    payOnDelivery: 0,
                    payCredit: 0,
                    creditPeriodId: null,
                }
            }
        }
        if (event.target.name == "hodUser" && branch.isNewHODUser) {
            delete branch.isNewHODUser
        }
    
        setBranch({ ...branch })
    }

    const handleEditClick = (branchId) => {
        let isPermitted = false
        if (companyData?.buyerSeller === 1) {
            const permissionDetails = checkPermissions({ ...userDetails, permissions: [29] })
            isPermitted = permissionDetails.isPermitted
        } else if (companyData?.buyerSeller === 2 || companyData?.buyerSeller === 3) {
            const permissionDetails = checkPermissions({ ...userDetails, permissions: [28] })
            isPermitted = permissionDetails.isPermitted
        }

        if (branchId === branch.branchId) {
            if (!branch.isEditing && isPermitted) {
                branch.isEditing = true
            } else if (!isPermitted) {
                return dispatch(raiseToast({ severity: 'error', detail: `Active User Role doesn't have access to edit the branch details.`, life: 3000 }))
            }
        }

        setBranch({ ...branch })
        props.setModifiedBranchId(branch.branchId)
    }

    const handleDiscardCompanyChanges = () => {
        if (window.confirm("Do you want to discard the changes")) {
            setBranch({ ...props.branch, moveShipAddrsList: [] })
            props.setUserRoles([...props.prevUserRoles])
            props.setModifiedBranchId(null)
        }
    }

    const companyUsersSearchMethod = (event) => {
        const relatedCompanyUsers = companyData.companyUsers?.filter(eachUser => eachUser.firstName?.toLowerCase().includes(event.query?.trim()?.toLowerCase()))
        if (relatedCompanyUsers.length > 0) {
            setCompanyUsersSuggestions(relatedCompanyUsers)
        } else {
            setCompanyUsersSuggestions([])
        }
    }

    const dispalyApproverDetails = (allApprovers) => {
        let approverNames = []
        allApprovers.map(eachApprover => {
            approverNames.push(eachApprover.fullName)
        })
        return approverNames.join(", ")
    }

    const getApprovarDetailsData = (selectedApprovalId) => {
        let relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === selectedApprovalId)
        const pmCompanyUsers = pmCompanyDetails.companyUsers ? pmCompanyDetails.companyUsers : []
        const pmCompanyRoles = pmCompanyDetails.companyRoles ? pmCompanyDetails.companyRoles : []
        const pmBranches = pmCompanyDetails.companyBranches ? pmCompanyDetails.companyBranches : []

        const pmBranchId = null
        const createdBy = null

        if(relatedApproval){
            const approvalDetails = getApproverDetails(relatedApproval, pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)
            return approvalDetails
        } else {
            return []
        }
    }

    const renderApprovalDetailsDisplay = (relatedApprovalInstance, approvalTypeId) => {
        let approvalInstanceStatus = statusList.find((status) => status.statusId == relatedApprovalInstance.statusId)?.status

        let approvalRequestType = ""
        let approvalDesc = ""
        let tooltipName = ""
        if (approvalTypeId === 39) {

            let approvalPaymentTerms = {}
            if(relatedApprovalInstance.approvedMetrics.paymentTerms){
                approvalPaymentTerms = relatedApprovalInstance.approvedMetrics.paymentTerms
            }
            
            approvalRequestType = "Requested payment terms"
            tooltipName = "payment-terms"

            if(approvalPaymentTerms.payAdvPO){
                approvalDesc += `Adv against PO (%): ${approvalPaymentTerms.payAdvPO},\n`
            }

            if(approvalPaymentTerms.payAdvDelivery){
                approvalDesc += `Adv before Delivery (%): ${approvalPaymentTerms.payAdvDelivery},\n`
            }

            if(approvalPaymentTerms.payPDCDelivery){
                approvalDesc += `PDC on Delivery (%): ${approvalPaymentTerms.payPDCDelivery},\n`
            }

            if(approvalPaymentTerms.payOnDelivery){
                approvalDesc += `Pay against Delivery (%): ${approvalPaymentTerms.payOnDelivery},\n`
            }

            if(approvalPaymentTerms.payCredit){
                approvalDesc += `Credit (%): ${approvalPaymentTerms.payCredit},\n`
            }

            let relatedCreditPeriod = null
            if(approvalPaymentTerms.creditPeriodId){
                relatedCreditPeriod = props.creditPeriods.find(eachCreditPeriod => eachCreditPeriod.creditPeriodId === approvalPaymentTerms.creditPeriodId)
                if(relatedCreditPeriod){
                    approvalDesc += `Credit Period: ${relatedCreditPeriod.creditPeriodName}`
                }
            }
        }

        let approvalDetails = getApprovarDetailsData(approvalTypeId)

        return (
            <div className="md:col-1 lg:col-1 pl-0 flex justify-content-end py-0">
                <Tooltip target={`.custom-tool-tip-company-${tooltipName}-approval-status${props.selectedBranchId}`} position="top" autoHide >
                    <p className='m-0'><b>{approvalRequestType}: </b>  {approvalDesc} </p>
                    <p className='m-0'><b>Approver:</b>  {dispalyApproverDetails(approvalDetails)} </p>
                    <p className='m-0'><b>Status:</b>  {approvalInstanceStatus} </p>
                    { approvalTypeId === 39 && approvalInstanceStatus === "REJECTED" ? <p className='m-0'><b>Remarks: </b>  {relatedApprovalInstance.processedRemarks} </p> : ""}
                </Tooltip>
                <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png" className={`text-xs mb-1 mr-2 custom-tool-tip-company-${tooltipName}-approval-status${props.selectedBranchId} cursor-auto`} style={{ height: "35px", width: "30px", marginTop:"10px"}} />
            </div>
        )
    }

    const handleGetGoogleUserChatUri = async (approvalEmail) => {
        if (!approvalEmail) {
            return dispatch(raiseToast({ severity: 'error', detail: "Approval user not found. Please contact tech team", life: 3000 }))
        }
        let data = {
            userId: userDetails.userId,
            emailId: approvalEmail
        }

        props.setIsLoaderVisible(true)
        const getGoogleUserChatUriRes = await getGoogleUserChatUri(data)
        props.setIsLoaderVisible(false)

        if (getGoogleUserChatUriRes.failure) {
            if (window.confirm("Chat with the user doesn't exist.\nPlease open chat manually, and send the message.")) {
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank')
            }
        } else {
            window.open(getGoogleUserChatUriRes.data, '_blank')
        }
    }

    const phoneNumberBody = (row) => {
        let phoneNumber = row.phoneNumber
        if(row.user){
            phoneNumber = row.user.phoneNumber
        }
        if (phoneNumber) {
            return (
                <div className='flex'>
                    <p style={{ cursor: "pointer", padding: "0px", margin: "0px" }}>{phoneNumber}</p>
                    <div style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${phoneNumber}`)}>
                        <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: "#00baaa" }}></i>
                    </div>
                </div>
            )
        }

        return "-"
    }

    const emailIdBody = (row) => {
        let emailId = row.emailId
        if(row.user){
            emailId = row.user.emailId
        }
        if (emailId) {
            return (
                <div className='flex'>
                    <p onClick={() => navigate(`/editUser/${row.userId}`)} style={{ fontSize: "13px", cursor: "pointer", padding: "0px", margin: "0px" }}>{emailId}</p>
                    <a style={{ cursor: "pointer" }} onClick={() => handleGetGoogleUserChatUri(emailId)}>
                        <img
                            className="ml-1 mb-0 mt-0"
                            src={googleChatIcon}
                            style={{ height: 13 }}
                            alt="Google Chat"
                        />
                    </a>
                </div>
            )
        }

        return "-"
    }

    const userNameBody = (row) => {
        let firstName = row.firstName
        let lastName = row.lastName

        if(row.user){
            firstName = row.user.firstName
            lastName = row.user.lastName
        }

        return getFullName(firstName, lastName)
    }

    const pmBranchesBody = (row) => {
        const pmBranches = pmCompanyDetails.companyBranches ? pmCompanyDetails.companyBranches : []
        let relatedPMBranches = pmBranches.filter(eachBranch => row.pmBranchIds.includes(eachBranch.branchId))
        const pmBranchNames = _.uniqBy(relatedPMBranches, 'branchId').map(eachPMBranch => eachPMBranch.branchName)

        if(pmBranchNames.length){
            return pmBranchNames.join(", ")
        }

        return "-"
    }

    const companyUsersTableColumns = [
        {
            header: 'User Name',
            field: '',
            body: userNameBody,
        },
        {
            header: 'Phone Number',
            field: 'phoneNumber',
            body: phoneNumberBody
        },
        {
            header: 'Email Id',
            field: 'emailId',
            body: emailIdBody
        }
    ]

    const relevantKamsTableColumns = [
        {
            header: 'User Name',
            field: '',
            body: userNameBody,
        },
        {
            header: 'Phone Number',
            field: 'phoneNumber',
            body: phoneNumberBody
        },
        {
            header: 'Email Id',
            field: 'emailId',
            body: emailIdBody
        },
        {
            header: 'PM Branches',
            field: '',
            body: pmBranchesBody
        }
    ]

    let total_payment = 0
    let payment_terms = { ...branch.paymentTerms }
    delete payment_terms.creditPeriodId
    const payment_values = Object.values(payment_terms)
    payment_values.map((value) => {
        if (value) {
            total_payment += parseFloat(value)
        }
    })

    const companyGSTINOptionTemplate = (option) => {
        let lineItemColor = ``
        if ([2, 20].includes(option.statusId)) {
            lineItemColor = `#F1592A`
        }
        else if ([21, 22].includes(option.statusId)) {
            lineItemColor = `#cfbf32`
        }
        else {
            lineItemColor = `#13A89D`
        }

        return(
            <>
                <span className="" style={{color: lineItemColor}}>{option.gstinCode}{option.statusId === 20 ? ' ᵇˡᵃᶜᵏˡᶦˢᵗᵉᵈ ' : ''}{option.exemptedSEZ ? ' ˢᵉᶻ ' : ''}</span>
            </>
        )
    }
    
    const branchUsers = props.userRoles
        .filter(eachUserRole => eachUserRole.branchId === branch.branchId)
        .sort((roleA, roleB) => {
            let companyRoleNameA = companyData.companyRoles?.find(eachCompanyRole => eachCompanyRole.companyRoleId === roleA.companyRoleId)?.companyRoleName || ''
            let companyRoleNameB = companyData.companyRoles?.find(eachCompanyRole => eachCompanyRole.companyRoleId === roleB.companyRoleId)?.companyRoleName || ''

            if (companyRoleNameA < companyRoleNameB) return -1
            if (companyRoleNameA > companyRoleNameB) return 1
            return roleA.user?.firstName.localeCompare(roleB.user?.firstName)
        })

    const reletedRelevantKams = relevantKams.filter(eachKam => eachKam.branchIds.includes(branch.branchId))

    
    let showRejectedPaymentTermsApprovalStatus = false
    if([2, 3].includes(props.companyData?.buyerSeller) && paymentTermsApprovalInstanceData){
        if(paymentTermsApprovalInstanceData.statusId === 8 && paymentTermsApprovalInstanceData.processedTS){
            showRejectedPaymentTermsApprovalStatus = Date.parse(branch.updatedAt) > Date.parse(paymentTermsApprovalInstanceData.processedTS)
        }
    }

    let addBranchPermissions = []
    let editBranchPermissions = []
    let deleteBranchPermissions = []

    if([1,3].includes(companyData?.buyerSeller)){
        addBranchPermissions = [163]
        editBranchPermissions = [163]
        deleteBranchPermissions = [164]
    }else{
        editBranchPermissions = [165]
        deleteBranchPermissions = [165]
    }

    if(companyData?.prefPMBranchId == branch?.branchId){
        editBranchPermissions.push(138)
    }

    const updatedGSTINs = props.gstinList.filter(eachGSTIN => {
        if(branch.exemptedSEZ){
            if(eachGSTIN.exemptedSEZ){
                return true
            }
            else{
                return false
            }
        }
        else{
            if(eachGSTIN.exemptedSEZ){
                return false
            }
            else{
                return true
            }
        }
    })

    let filteredCompanyTypes = companyTypes.filter(eachCompanyType => eachCompanyType.companyTypeId !== 3)

    if(companyData.buyerSeller !== 3){
        filteredCompanyTypes = companyTypes.filter(eachCompanyType => eachCompanyType.companyTypeId === companyData.buyerSeller)
    }

    let editButtonTooltipTxt = ""
    if (companyData.statusId === 2){
        editButtonTooltipTxt = "Edit branch is disabled because the company is inactive."
    }
    
    const handleMoveShipAddr = (e, shipAddrId) => {
        setSelectedShipAddrId(shipAddrId)
        moveShipAddrRef.current.toggle(e)
    }

    useEffect(() => {
        const updatedFields = {}

        if (props.prefPMStateList.length === 1 && !branch.prefPMStateId) {
            updatedFields.prefPMStateId = props.prefPMStateList[0].stateId
        }

        if (props.pmCompanyDetails.companyBranches.length === 1 && !branch.prefPMBranchId) {
            updatedFields.prefPMBranchId = props.pmCompanyDetails.companyBranches[0].branchId
        }

        if (props.pmCompanyDetails.companyBankAccounts?.length === 1 && !branch.prefPMBankId) {
            updatedFields.prefPMBankId = props.pmCompanyDetails.companyBankAccounts[0].bankAccId
        }

        if (clientSuccessManagers.length === 1 && !branch.clientSuccessManagerId) {
            updatedFields.clientSuccessManagerId = clientSuccessManagers[0]
        }

        if (filteredCompanyTypes.length === 1 && !branch.buyerSeller) {
            updatedFields.buyerSeller = filteredCompanyTypes[0].companyTypeId
        }

        if (Object.keys(updatedFields).length > 0) {
            setBranch(prev => ({ ...prev, ...updatedFields }))
        }
    }, [
        props.prefPMStateList,
        props.pmCompanyDetails.companyBranches,
        props.pmCompanyDetails.companyBankAccounts,
        clientSuccessManagers,
        filteredCompanyTypes
    ])

    const removeSelectedBranchToMoveShipAddr = (shipAddrId) => {
        const updatedMoveList = branch.moveShipAddrsList.filter(eachShipAddr => eachShipAddr.shipAddrId !== shipAddrId)
        setBranch(prev => ({ ...prev, moveShipAddrsList: updatedMoveList }))
    }

    const handleSelectBranchToMoveShipAddr = (e)=> {
        const moveShipAddr = {
            shipAddrId: selectedShipAddrId,
            fromBranchId: branch.branchId,
            toBranch: e.target.value
        }
        
        let updatedPrimaryShipAddrId = branch.primaryShipAddrId
        if(branch.primaryShipAddrId === selectedShipAddrId){
            updatedPrimaryShipAddrId = null
        }

        const updatedMoveList = [...branch.moveShipAddrsList, moveShipAddr]
        setBranch(prev => ({ ...prev, moveShipAddrsList: updatedMoveList, primaryShipAddrId: updatedPrimaryShipAddrId }))
        
        setSelectedBranchToMoveShipAddr(null)
        moveShipAddrRef.current.hide()
    }
    
    const handleShipAddrStatusChange = (shipAddrId, statusId) => {
        const newStatusId = statusId === 1 ? 2 : 1
    
        const updatedShipAddrArr = branch.shipAddrArr.map(eachAddr => {
            if (eachAddr.shipAddrId === shipAddrId) {
                return { ...eachAddr, statusId: newStatusId }
            }
            return eachAddr
        })

        let updatedPrimaryShipAddrId = branch.primaryShipAddrId
        if(newStatusId === 2 && branch.primaryShipAddrId === shipAddrId){
            updatedPrimaryShipAddrId = null
        }
    
        setBranch(prev => ({ ...prev, shipAddrArr: updatedShipAddrArr, primaryShipAddrId: updatedPrimaryShipAddrId }))
    }

    const {isPermitted: canAddNewShipAddress} = checkPermissions({ ...userDetails, userRoleId: userDetails.activeRoleId, permissions: [209] })

    const cardWidth = 320
    const totalCards = branch?.shipAddrArr?.length || 0
    const columns = Math.ceil(totalCards / 2) 
    
    return (
        <>
            <div className='mb-1 flex justify-content-between mb-3'>
                <div className="flex align-items-center">
                    <label className="text-sm mr-2 text-600 font-semibold"> SEZ </label>
                    <InputSwitchField className="" name="exemptedSEZ" checked={branch.exemptedSEZ ? branch.exemptedSEZ : false} onChange={(event) => handleToggleSwitchButtonChange(event)} disabled={!branch.isEditing} />
                </div>
                <>
                    {
                        typeof (branch.branchId) === "number" ?
                            branch.isEditing ?
                                <div>
                                    <Button className="small-btn discard-btn" style={{ marginRight: "10px" }} label="DISCARD" severity="warning" onClick={() => handleDiscardCompanyChanges(branch)} />
                                    <Button className="small-btn" label="UPDATE" onClick={() => props.handleUpdateCompanyBranch(branch)} />
                                </div>
                                :
                                <Button className="small-btn" label="EDIT" onClick={() => handleEditClick(branch.branchId)} permissions={editBranchPermissions} disabled={branch.statusId === 2 || companyData.statusId === 2} tooltip={editButtonTooltipTxt} tooltipOptions={{ position: "top", showOnDisabled: true }} />

                            :
                            <Button className="small-btn" label="Add Branch" onClick={() => props.handleAddNewCompanyBranch(branch)} permissions={addBranchPermissions} />
                    }
                </>
            </div>

            <div className='grid'>
            </div>

            <div className="grid" key={branch.branchId}>
                <div className="flex flex-column col-12 md:col-4">
                    <TextInputField name="branchName" labelText="Branch Name" value={branch.branchName} maxLength={255} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} errorMessage={validationBranchId === branch.branchId && formErrors.branchName} required />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <DropDownField name="branchType" labelText="Branch Type" options={branchTypeOptions} value={branch.branchType} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} errorMessage={validationBranchId === branch.branchId && formErrors.branchType} required />
                </div>
                <div className="flex flex-column col-12 mb-2 md:col-4">
                    <MultiSelectField name="branchGSTINs" labelText={`${pmCompanyConfig.GSTINLabel}`} options={updatedGSTINs} itemTemplate={companyGSTINOptionTemplate} optionLabel="gstinCode" optionValue="gstinCode" value={branch.branchGSTINs} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} errorMessage={validationBranchId === branch.branchId && formErrors.branchGSTINs} required />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <DropDownField name="prefPMStateId" labelText="Pref. PM State" options={props.prefPMStateList} optionLabel="stateName" optionValue="stateId" value={branch.prefPMStateId} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <DropDownField name="prefPMBranchId" labelText="Pref PM Branch" options={prefPMBranches} optionLabel="branchName" optionValue="branchId" value={branch.prefPMBranchId} onChange={(event) => handleInputChange(event, branch.branchId)} optionDisabled="optionDisabled" disabled={!branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <DropDownField name="prefPMBankId" labelText="Pref PM Bank Account" options={pmCompanyDetails.companyBankAccounts} optionLabel="bankName" optionValue="bankAccId" value={branch?.prefPMBankId} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <DropDownField name="vmiEnabled" labelText="VMI Enabled" options={options} value={branch.vmiEnabled} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} />
                </div>
                {
                    companyData.buyerSeller === 1 || companyData.buyerSeller === 3 ?
                        <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                            <AutoCompleteField name="clientSuccessManagerId" labelText="Client Success Manager" field="fullName" placeholder="Select User" value={branch.clientSuccessManagerId} suggestions={searchedClientSuccessManagers} searchMethod={searchClientSuccessManagers} onChange={(event) => handleInputChange(event, branch.branchId)} dropdown forceSelection errorMessage={validationBranchId === branch.branchId && formErrors.clientSuccessManagerId} required disabled={!branch.isEditing} />
                        </div> : null
                }
                <div className="flex flex-column col-12 md:col-4">
                    <DropDownField name="buyerSeller" labelText="Buyer/Seller" placeholder={"Please Select"} optionLabel="companyType" optionValue="companyTypeId" options={filteredCompanyTypes} value={branch.buyerSeller} onChange={(event) => handleInputChange(event, branch.branchId)} errorMessage={validationBranchId === branch.branchId && formErrors.buyerSeller} required disabled={!branch.isEditing} />
                </div>
            </div>

            <div className="hr-line" />

            <div className="flex flex-column md:flex-row px-0">
                <div className={`flex col-12 mb-1 lg:col-3 lg:mb-0 align-items-center pl-0 py-0 ${[8, 12].includes(paymentTermsApprovalInstanceData?.statusId) ? `justify-content-between w-11rem` : `w-8rem`}`}>
                    <h5 className="text-600 mt-3 mb-2" >Payment Terms <span style={{ color: "red" }} className="from-required">*</span></h5>
                    {
                        [8, 12].includes(paymentTermsApprovalInstanceData?.statusId) && !showRejectedPaymentTermsApprovalStatus ? renderApprovalDetailsDisplay(paymentTermsApprovalInstanceData, 39) : ""
                    }
                </div>
                <div className="flex col-12 mb-1 md:col-4 lg:mb-0 align-items-center pl-0 py-0">
                    <label className="text-s mt-2 mr-2"> Use company payment terms: </label>
                    <InputSwitchField className="mt-2" name="companyPaymentTerms" checked={branch.companyPaymentTerms} onChange={(event) => handleInputChange(event, branch.branchId)} disabled={!branch.isEditing} />
                </div>
            </div>

            <div className="grid mt-1">
                <div className="flex flex-column col-12 md:col-2">
                    <TextInputField name="payAdvPO" labelText="Adv against PO (%)" keyfilter={"pnum"} value={branch?.paymentTerms?.payAdvPO} onChange={(event) => handlePaymentTermsChange(event, branch.branchId)} disabled={branch.companyPaymentTerms || !branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-2">
                    <TextInputField name="payAdvDelivery" labelText="Adv before Delivery (%)" keyfilter={"pnum"} value={branch?.paymentTerms?.payAdvDelivery} onChange={(event) => handlePaymentTermsChange(event, branch.branchId)} disabled={branch.companyPaymentTerms || !branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-2">
                    <TextInputField name="payPDCDelivery" labelText="PDC on Delivery (%)" keyfilter={"pnum"} value={branch?.paymentTerms?.payPDCDelivery} onChange={(event) => handlePaymentTermsChange(event, branch.branchId)} disabled={branch.companyPaymentTerms || !branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-2">
                    <TextInputField name="payOnDelivery" labelText="Pay against Delivery (%)" keyfilter={"pnum"} value={branch?.paymentTerms?.payOnDelivery} onChange={(event) => handlePaymentTermsChange(event, branch.branchId)} disabled={branch.companyPaymentTerms || !branch.isEditing} />
                </div>
                <div className="flex flex-column col-12 md:col-1">
                    <TextInputField name="payCredit" labelText="Credit (%)" keyfilter={"pnum"} value={branch?.paymentTerms?.payCredit} onChange={(event) => handlePaymentTermsChange(event, branch.branchId)} disabled={branch.companyPaymentTerms || !branch.isEditing} />
                </div>
                {
                    parseInt(branch?.paymentTerms?.payCredit) > 0 || parseInt(branch?.paymentTerms?.payPDCDelivery) > 0 ?
                        <div className="flex flex-column col-12 md:col-2">
                            <DropDownField name="creditPeriodId" labelText="Credit Period" options={props.creditPeriods} value={branch?.paymentTerms?.creditPeriodId} optionLabel="creditPeriodName" optionValue="creditPeriodId" onChange={(event) => handlePaymentTermsChange(event, branch.branchId)} disabled={branch.companyPaymentTerms || !branch.isEditing} />
                        </div> : ""
                }
                <div className="flex flex-column col-12 md:col-1 align-items-center justify-content-center mt-2 pl-0">
                    <p className={`font-bold m-0 text-${total_payment == 100 ? 'green-600' : 'red-500'}`}> {total_payment} </p>
                </div>
            </div>

            <div className="hr-line" />

            <div>
                <h5 className="text-600 mt-3 mb-2">Shipping Address <span style={{ color: "red" }} className="from-required">*</span></h5>
                <div className="">
                    <div className="increment-btn ml-2">
                        <Button className="increment-btn-icon" icon="pi pi-plus-circle" text size="large" onClick={() => props.onClickOpenShippingAddrModal(branch.branchId)} disabled={!branch.isEditing || !canAddNewShipAddress} />
                    </div>
                    <Dialog header="Add New Shipping Address" className='add-new-shipping-address' visible={props.visibleAddNewShippingAddr} style={{ width: '50vw', minHeight: "35%" }} onHide={() => props.setVisibleAddNewShippingAddr(branch.branchId)} >
                        <AddShippingAddress stateList={props.stateList} countriesData={props.countriesData} handleSubmit={addCompanyBranchShippingAddr} pinCodesData={props.pinCodesData} />
                    </Dialog>
                </div>
                <div className='shipping-address-container' style={{ width: "100%", overflowX: 'auto', overflowY: 'hidden' }}>
                    <div className="grid ship-card-container max-h-24rem" style={{ gridTemplateColumns: `repeat(${columns}, ${cardWidth}px)`, width: `${columns * (cardWidth + 10)}px`, display: 'grid', gridAutoFlow: 'column', gridTemplateRows: 'repeat(2, auto)',  columnGap: '8px',  rowGap: '3px', height: 'auto'}}>
                        {
                            branch?.shipAddrArr?.length > 0 && branch.shipAddrArr?.map((addr) => {
                                let isPrimaryShipAddr = branch.primaryShipAddrId === addr.shipAddrId
                                let relatedState = props.stateList.find(state => state.stateId === parseInt(addr.stateId))
                                const relatedMoveShipAddr = branch.moveShipAddrsList.find(eachShipAddr => eachShipAddr.shipAddrId === addr.shipAddrId)
                                return (
                                    <div key={addr.shipAddrId} className="border-solid border-1 shipping-add-card border-300 border-around-1 m-2 mb-1 border-round justify-content-between text-xs" 
                                        style={{ 
                                            backgroundColor: isPrimaryShipAddr ? '#ebf7ef' : '#fafafaa3', 
                                            width: `${cardWidth}px`,
                                            padding: '0.5rem',
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            minHeight: '120px', 
                                        }}>
                                        <div className='flex p-1 flex-column'>
                                            <div className=''><span className='text-900 font-medium'>Address:</span> {addr?.shipAddr} </div>
                                            <div className=''><span className='text-900 font-medium'>City:</span>{addr?.city} </div>
                                            <div className=''><span className='text-900 font-medium'>State:</span> {relatedState?.stateName} </div>
                                            {/*<div className=''>Country: {companyData?.country?.countryName}</div>*/}
                                            <div className=''><span className='text-900 font-medium'>Pin:</span> {addr?.pinCode} </div>
                                        </div>
                                        <div className="flex justify-content-between align-items-center mt-2">
                                            <div className="flex align-items-center">
                                                <RadioButton inputId="primaryShipAddrId" name="primaryShipAddrId" value={addr.shipAddrId} onChange={(event) => handleInputChange(event, branch.branchId)} checked={branch.primaryShipAddrId === addr.shipAddrId} disabled={!branch.isEditing || addr.statusId === 2 || relatedMoveShipAddr } />
                                                <label htmlFor="primaryShipAddrId" className="ml-1 text-xs mb-1">{ branch.primaryShipAddrId === addr.shipAddrId ? <span style={{color: "orange", fontWeight: "bold"}}>Primary Address</span> : "Set as primary"} </label>
                                            </div>

                                            <div className="flex align-items-center gap-2">
                                                { branch.isEditing && 
                                                    <>
                                                        <InputSwitchField
                                                            name="companyPaymentTerms"
                                                            checked={addr.statusId === 1}
                                                            onChange={() => handleShipAddrStatusChange(addr.shipAddrId, addr.statusId)}
                                                        />

                                                        {relatedMoveShipAddr ? (
                                                            <div className="flex align-items-center gap-2">
                                                                <span>Moved to <b>{relatedMoveShipAddr.toBranch.branchName}</b></span>
                                                                <Button
                                                                    icon="pi pi-times"
                                                                    className="p-button-danger p-button-text p-0"
                                                                    style={{ width: '15px', height: '24px' }}
                                                                    onClick={() => removeSelectedBranchToMoveShipAddr(addr.shipAddrId)}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <Button
                                                                label="Move"
                                                                style={{ width: '60px', height: '12px', fontSize: "12px" }}
                                                                onClick={(e) => handleMoveShipAddr(e, addr.shipAddrId)}
                                                                permissions={[211]}
                                                            />
                                                        )}
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            {
                reletedRelevantKams.length ? (
                    <div>
                        <div className="hr-line" />
                        <div className='flex align-items-center mt-1' style={{ cursor: "pointer", fontSize: "14px", color: "#00baaa" }} onClick={() => setViewRelevantKams(!viewRelevantKams)}>
                            <i className={`pi ${viewRelevantKams ? "pi-angle-down" : "pi-angle-right"}`} style={{ fontSize: '1rem' }}></i>
                            <div>
                                <label htmlFor="" style={{ cursor: "pointer" }}>
                                    {`${viewRelevantKams ? "Hide" : "View"} Relevant Kams`}
                                    <Tooltip target=".relevant-buyer-req-kams" position="top" content="These KAMs have created buyer requirements in the last 45 days." />
                                    <i className="pi pi-info-circle company-level-users-tooltip ml-1"></i>
                                </label>
                            </div>
                        </div>
                        {
                            viewRelevantKams &&
                            <div className="mt-2" style={{ order: "1" }}>
                                <div className="p-card company-level-user-table" style={{ backgroundColor: "#edf2f0" }}>
                                    <Table
                                        lazy
                                        tableColumns={relevantKamsTableColumns}
                                        data={reletedRelevantKams}
                                        scrollable={"true"}
                                        scrollHeight="550px"
                                        style={{ backgroundColor: "#edf2f0", order: "1" }}
                                    />
                                </div>
                            </div>
                        }
                        <Tooltip target=".relevant-buyer-req-kams" position="top" content="This user has company level access - to edit, Please go to Companies tab." />
                    </div>
                ) : null
            }
            {
                companyLevelUsers.length ? (
                    <div>
                        <div className="hr-line" />
                        <div className='flex align-items-center mt-1' style={{ cursor: "pointer", fontSize: "14px", color: "#00baaa" }} onClick={() => setViewCompanyLevelUsers(!viewCompanyLevelUsers)}>
                            <i className={`pi ${viewCompanyLevelUsers ? "pi-angle-down" : "pi-angle-right"}`} style={{ fontSize: '1rem' }}></i>
                            <div>
                                <label htmlFor="" style={{ cursor: "pointer" }}>
                                    {`${viewCompanyLevelUsers ? "Hide" : "View"} Company Level Users`}
                                    <Tooltip target=".company-level-users-tooltip" position="top" content="These users has company level access - to edit, Please go to Companies tab." />
                                    <i className="pi pi-info-circle company-level-users-tooltip ml-1"></i>
                                </label>
                            </div>
                        </div>
                        {
                            viewCompanyLevelUsers &&
                            <div className="text-align-center mt-2" style={{ order: "1" }}>
                                <div className="p-card company-level-user-table" style={{ backgroundColor: "#edf2f0" }}>
                                    <Table
                                        lazy
                                        tableColumns={companyUsersTableColumns}
                                        data={companyLevelUsers}
                                        scrollable={"true"}
                                        scrollHeight="550px"
                                        style={{ backgroundColor: "#edf2f0", order: "1" }}
                                    />
                                </div>
                            </div>
                        }
                        <Tooltip target=".company-level-user-disabled" position="top" content="This user has company level access - to edit, Please go to Companies tab." />
                    </div>
                ) : null
            }
            <div className="hr-line" />
            <div className="mt-3 mb-2 flex flex-column lg:flex-row justify-content-between">
                <div>
                    <h5 className="text-600 mb-2">Users</h5>
                </div>
                <div className="flex flex-column col-12 md:col-3 px-0">
                    <label htmlFor="groupId" style={{ fontSize: "12px", marginBottom: "3px" }}>
                        Assign Users
                        <Tooltip target=".assign-users-eye-icon" position="top" content="Please add users from users tab and assign roles here" />
                        <i className="pi pi-info-circle assign-users-eye-icon ml-2"></i>
                    </label>
                    <AutoCompleteField name="hodUser" labelText="" value={props.userName} placeholder="Search user" field="firstName" searchMethod={companyUsersSearchMethod} suggestions={companyUsersSuggestions} onChange={(e) => props.handleAddUserRoleToBranch(e, branch.branchId, branch.isNew)} dropdown forceSelection disabled={!branch.isEditing} />
                </div>
            </div>
            <div>
                {viewCompanyLevelUsers || viewRelevantKams ? <h5 className="text-600 mb-2 pb-0">Branch Users</h5> : null}
                {
                    branchUsers.map((eachUserRole, index) => {
                        let relatedBranchManagers = [...branchUsers]
                        if (props.companyId === pmCompanyDetails.companyId) {
                            let relatedCompanyRoleHierarchy = companyRoleHierarchy.filter(eachCompanyRole => eachCompanyRole.companyRoleId === eachUserRole.companyRoleId)

                            if (relatedCompanyRoleHierarchy.length > 0) {
                                const parentRoleIds = _.uniqBy(relatedCompanyRoleHierarchy, 'parentRoleId').map(obj => obj.parentRoleId)
                                let isCompanyLevelRole = [1, 8, 10].includes(parentRoleIds[0])
                                let companyRoleHierarchyUserIds = []
                                if (isCompanyLevelRole) {
                                    companyRoleHierarchyUserIds = props.userRoles
                                        .filter(eachRole => parentRoleIds.includes(eachRole.companyRoleId) && eachRole.statusId === 1)
                                        .map(eachRole => eachRole.userId)
                                } else {
                                    companyRoleHierarchyUserIds = props.userRoles
                                        .filter(eachRole => parentRoleIds.includes(eachRole.companyRoleId) && eachRole.branchId === eachUserRole.branchId && eachRole.statusId === 1)
                                        .map(eachUserRole => eachUserRole.userId)
                                }

                                if (companyRoleHierarchyUserIds.length > 0) {
                                    relatedBranchManagers = props.userRoles.filter(eachRole => companyRoleHierarchyUserIds.includes(eachRole.userId) && eachRole.statusId === 1)
                                }
                            }
                        }

                        relatedBranchManagers = _.uniqBy(relatedBranchManagers, 'userId')

                        return (
                            <div key={`UserRole-${eachUserRole.userRoleId}`} className="grid" style={{ marginBottom: "-1.5rem"}}>
                                <div className="flex flex-column col-12 md:col-2">
                                    <TextInputField name="Name" labelText={index === 0 ? "Name" : ""} value={`${getFullName(eachUserRole.user?.firstName, eachUserRole.user?.lastName)}`} disabled maxLength={100} />
                                </div>
                                <div className="flex flex-column col-12 md:col-3">
                                    <TextInputField name="emailId" labelText={index === 0 ? "Email" : ""} value={eachUserRole.user?.emailId} disabled maxLength={100} />
                                </div>
                                <div className="flex col-12 md:col-5 p-0">
                                    <div className="flex flex-column col-12 md:col-4">
                                        <TextInputField name="phoneNumber" labelText={index === 0 ? "Phone" : ""} value={eachUserRole.user?.phoneNumber} disabled maxLength={10} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="companyRoleId" labelText={index === 0 ? "Role" : ""} options={companyData.companyRoles} optionValue="companyRoleId" optionLabel="companyRoleName" value={eachUserRole.companyRoleId} onChange={(e) => { props.handleUserRoleChange(e, eachUserRole.userRoleId) }} disabled={!eachUserRole.isNew || !branch.isEditing} errorMessage={formErrors[`userRoles[${index}].companyRoleId`]} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="managerId" labelText={index === 0 ? "Manager" : ""} options={relatedBranchManagers} optionValue="userId" optionLabel={(eachRole) => eachRole.user.lastName ? `${eachRole.user.firstName} ${eachRole.user.lastName}` : `${eachRole.user.firstName}`} value={eachUserRole.managerId} onChange={(e) => { props.handleManagerChange(e, eachUserRole.userId, eachUserRole.userRoleId) }} disabled={!branch.isEditing} errorMessage={formErrors[`userRoles[${index}].managerId`]} />
                                    </div>
                                </div>
                                <div className="flex col-12 md:col-2 p-0">
                                    <div className="flex flex-column col-12 md:col-8">
                                        {index === 0 ? <label style={{ fontStyle: "12px", color: "#495057" }}>Whatsapp/GChat</label> : null}
                                        <div className="flex col-12 md:col-8">
                                            <div className="col-6 md:col-8" style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${eachUserRole.user?.phoneNumber}`)}>{eachUserRole.user?.phoneNumber && <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: "#00baaa" }}></i>}</div>
                                            <a style={{ cursor: "pointer" }} className="col-6 md:col-8" onClick={() => handleGetGoogleUserChatUri(eachUserRole.user?.emailId)}>
                                                <img
                                                    className="ml-1 mb-0 mt-0"
                                                    src={googleChatIcon}
                                                    style={{ height: 13 }}
                                                    alt="Google Chat"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <InputSwitchField className="mt-3" name="statusId" labelText={index === 0 && !viewCompanyLevelUsers ? "Status" : ""} onChange={(e) => { props.handleUserRoleStatusChange(e, eachUserRole.userRoleId, eachUserRole) }} checked={eachUserRole.statusId === 1 ? true : false} disabled={!branch.isEditing} />
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <OverlayPanel ref={moveShipAddrRef} style={{ width: '246px', minHeight: "8px" }} dismissable>
                <div className="p-card mb-0">
                    <div className="grid">
                        <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                            <DropDownField
                                labelText="Select branch"
                                options={filteredBranchForShipAddrMove}
                                optionLabel="branchName"
                                value={selectedBranchToMoveShipAddr}
                                onChange={handleSelectBranchToMoveShipAddr}
                                required
                            />
                        </div>
                    </div>
                </div>
            </OverlayPanel>
        </>
    )
}

export default AddBranch